import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'
import {dataToOrderAuditList} from '../parsing'
import {useLocation} from 'react-router-dom'
import {useEffect} from 'react'

const useGetOrderAuditList = () => {
  const Api = useApi()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const view = searchParams.get('view')

  const initialFilters = {
    page: 1,
    limit: 30,
    search: '',
    sort_by: 'updated_at/-1',
    sales_rep: '',
    is_archived: view === 'archived' ? true : '',
  }

  const {filters, onSearch, onSortingChange, onPageChange, setSingleFilter, setMultipleFilters} =
  useFilters(initialFilters, {
    sortType: 'number',
  })
  
  useEffect(() => {
    setMultipleFilters({
      search: '',
      sales_rep: '',
      page: 1,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view])

  const {data: response, isFetching} = Api.useGetQuery('/orders/price-audit/report', {
    queryId: 'order-audit-list',
    filters: filters,
  })

  const onChangeSalesRepFilter = (selectedOption: any) => {
    setSingleFilter('sales_rep', selectedOption)
  }

  return {
    orderAuditList: dataToOrderAuditList(response?.data || []),
    pagination: response?.pagination || {},
    isLoading: isFetching,
    filters,
    onSearch,
    onPageChange,
    onSortingChange,
    onChangeSalesRepFilter,
  }
}

export default useGetOrderAuditList
